import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/shadcn/utils';
import { Button } from '@/modules/ui/components/button/Button';

interface ConnectLinkedInLinkProps {
  /** The Integrations page, with the portal's search suffix. */
  to: string;
  /** The account was connected before, so the user signs in to it again. */
  reconnect?: boolean;
  /** Keeps the current page, such as an unsaved draft, while LinkedIn's sign-in runs. */
  newTab?: boolean;
  /** `button` for a line's action; `link` inside a sentence. */
  variant?: 'link' | 'button';
}

/** Sends the user to Integrations to connect the LinkedIn Finlay sends from. */
export function ConnectLinkedInLink({
  to,
  reconnect = false,
  newTab = false,
  variant = 'link',
}: ConnectLinkedInLinkProps) {
  const link = (
    <Link
      className={
        variant === 'link'
          ? cn(
              'text-primary-700 font-medium hover:underline',
              newTab && 'inline-flex items-center gap-0.5',
            )
          : undefined
      }
      {...(newTab && { rel: 'noopener', target: '_blank' })}
      to={to}
    >
      {reconnect ? 'Reconnect LinkedIn' : 'Connect LinkedIn'}
      {newTab && (
        <>
          <ArrowUpRight aria-hidden className="size-3.5" />
          <span className="sr-only"> (opens in a new tab)</span>
        </>
      )}
    </Link>
  );
  return variant === 'button' ? (
    <Button asChild className="h-8 rounded-md" size="sm">
      {link}
    </Button>
  ) : (
    link
  );
}
